import type { ApolloQueryResult } from '@apollo/client';
import { ProductJsonLd } from 'next-seo';
import type { ReactElement } from 'react';

import type { ContentfulSelectorModalByMarketingPartnerQuery } from '@/graphql/contentful/api';
import type { OrderAppProductVariantBusinessDetailsFragment } from '@/graphql/orderApp/api';
import type {
  ProductsByMarketingPartnerQuery,
  ProductVariantWatchBasicDetailsFragment,
} from '@/graphql/saleor/api';
import type { CmsExtraDataRecord } from '@/integrations/contentful';
import { Default } from '@/layouts/Default';
import type { ProductStructuredData } from '@/lib/seo/SeoVariables';
import { DraftModeContext } from '@/providers/DraftModeProvider/DraftModeContext';

import type { PdpCmsData } from './WatchView';
import { WatchView } from './WatchView';

export interface WatchViewWrapperProps {
  businessData: OrderAppProductVariantBusinessDetailsFragment;
  cmsData: PdpCmsData[];
  cmsExtraDataRecord: CmsExtraDataRecord;
  marketingPartnerProductsResult: ApolloQueryResult<ProductsByMarketingPartnerQuery>;
  marketingSelectorModalResult:
    | NonNullable<
        ContentfulSelectorModalByMarketingPartnerQuery['selectorCollection']
      >['items'][0]
    | null;
  productStructuredData?: ProductStructuredData;
  productVariant: ProductVariantWatchBasicDetailsFragment;
}

export const WatchViewWrapper = ({
  businessData,
  cmsData,
  cmsExtraDataRecord,
  marketingPartnerProductsResult,
  marketingSelectorModalResult,
  productVariant,
}: WatchViewWrapperProps) => {
  return (
    <WatchView
      businessData={businessData}
      cmsData={cmsData}
      cmsExtraDataRecord={cmsExtraDataRecord}
      marketingPartnerProductsResult={marketingPartnerProductsResult}
      marketingSelectorModalResult={marketingSelectorModalResult}
      productVariant={productVariant}
    />
  );
};

WatchViewWrapper.getLayout = (page: ReactElement) => (
  <DraftModeContext.Provider value={page.props.draftMode}>
    <Default
      alertBannerHiddenOnMobile
      cmsData={page.props.cmsDefaultLayoutData}
      draftMode={page.props.draftMode}
    >
      <ProductJsonLd brand='Breitling' {...page.props.productStructuredData} />
      {page}
    </Default>
  </DraftModeContext.Provider>
);
